import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ReportsApiService } from '../services/account-api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { switchMap, map, catchError, of } from 'rxjs';
import { freeTrialApiActions, freeTrialPageActions } from './reports.actions';
import { DateService } from 'src/app/shared/services/date/date.service';

@Injectable()
export class ReportsEffects {
  private actions$ = inject(Actions);
  private reportsApiService = inject(ReportsApiService);
  private dateService = inject(DateService);
  private _snackBar = inject(MatSnackBar);

  exportAccount = createEffect(() =>
    this.actions$.pipe(
      ofType(freeTrialPageActions.userClickedDownloadReport),
      switchMap(() =>
        this.reportsApiService.exportFreeTrialReport().pipe(
          map((response) => {
            if (response) {
              const blob = new Blob([response], {
                type: 'text/csv;charset=utf-8;'
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `Nessy_FreeTrials_${this.dateService.getDateNowToLocaleDateString('en-GB')}.csv`;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);

              return freeTrialApiActions.loadFreeTrialReportSuccess();
            } else {
              this.openSnackBar('Failed to export free trials report, Please try again.');
              return freeTrialApiActions.loadFreeTrialReportFailure();
            }
          }),
          catchError(() =>
            of(
              freeTrialApiActions.loadFreeTrialReportFailure()
            )
          )
        )
      )
    )
  );

  openSnackBar(message: string) {
    this._snackBar.open(message, 'Close', {
      duration: 3000,
      horizontalPosition: 'right'
    });
  }
}
